/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useState } from "react";
export interface SearchResultStateInterface {
  offset?: number;
  count?: number;
  limit?: number;
  params: any;
  items: any[];
}

const searchResultInitState: SearchResultStateInterface = {
  offset: 0,
  limit: 0,
  params: {
    logonId: "",
    firstName: "",
    lastName: "",
    email1: "",
    phone1: "",
    address1: "",
    zipcode: "",
    country: "",
    state: "",
  },
  items: [],
};

export const CustomerContext: React.Context<any> = createContext({});
export const CustomerProvider = ({ children }: any) => {
  const [searchResult, setSearchResult] = useState<SearchResultStateInterface>(
    searchResultInitState
  );
  return (
    <CustomerContext.Provider value={{ searchResult, setSearchResult }}>
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomerValue = () => useContext(CustomerContext);
